import { useEffect, useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate, useSearchParams } from 'react-router';
import { Alert, AlertDescription } from '@xiltrion/ui/alert';
import { Button } from '@xiltrion/ui/button';
import { Field, FieldLabel } from '@xiltrion/ui/field';
import { Input } from '@xiltrion/ui/input';
import { InputClave } from '@xiltrion/ui/input-clave';
import { apiPost, apiGet, errorMessage } from '@/api/client';
import { entry } from '@/app/session';
import { MarcoSuite, TituloMarco } from './MarcoSuite';

export function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  return (
    <MarcoSuite>
      <TituloMarco titulo="Elige una contraseña nueva" subtitulo="Al menos 10 caracteres." />
      <form onSubmit={(e) => { e.preventDefault(); void apiPost('/auth/password/reset', { token: params.get('token'), password }).then(() => navigate('/ingreso'), (err) => setError(errorMessage(err))); }} className="space-y-4">
        {error && <Alert variant="destructive"><AlertDescription>{error}</AlertDescription></Alert>}
        <Field><FieldLabel htmlFor="np">Contraseña nueva</FieldLabel><InputClave id="np" minLength={10} required value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" /></Field>
        <Button type="submit" className="w-full">Guardar</Button>
      </form>
    </MarcoSuite>
  );
}

/** Activación de una cuenta invitada: nombre y primera contraseña; entra de una vez. */
export function ActivateAccount() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const { data } = useQuery({ queryKey: ['activate', token], queryFn: () => apiGet<{ valid: boolean; email: string | null; displayName: string | null }>('/auth/activate', { token }) });
  const [displayName, setDisplayName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (data?.displayName && !displayName) setDisplayName(data.displayName);
  }, [data, displayName]);
  if (data && !data.valid) {
    return (
      <MarcoSuite>
        <TituloMarco titulo="Enlace vencido" subtitulo="La invitación ya se usó o caducó." />
        <Alert variant="warning"><AlertDescription>Pide a tu administrador que te reenvíe la invitación, o usa «¿Olvidaste tu contraseña?» con tu correo.</AlertDescription></Alert>
        <Button variant="link" className="mt-2 w-full" onClick={() => navigate('/ingreso')}>Ir al ingreso</Button>
      </MarcoSuite>
    );
  }
  return (
    <MarcoSuite>
      <TituloMarco titulo="Activa tu cuenta" subtitulo={data?.email ? `Cuenta: ${data.email}` : undefined} />
      <form onSubmit={(e) => { e.preventDefault(); void apiPost('/auth/activate', { token, password, displayName }).then(async () => { entry.mark(); await qc.invalidateQueries({ queryKey: ['me'] }); navigate('/', { replace: true }); }, (err) => setError(errorMessage(err))); }} className="space-y-4">
        {error && <Alert variant="destructive"><AlertDescription>{error}</AlertDescription></Alert>}
        <Field><FieldLabel htmlFor="dn">Tu nombre</FieldLabel><Input id="dn" required value={displayName} onChange={(e) => setDisplayName(e.target.value)} /></Field>
        <Field><FieldLabel htmlFor="ap">Contraseña</FieldLabel><InputClave id="ap" minLength={10} required value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" /></Field>
        <Button type="submit" className="w-full">Activar y entrar</Button>
      </form>
    </MarcoSuite>
  );
}
